import { createApp } from "vue";
//import { Field, Form } from "vee-validate";
import App from "./App.vue";
import router from "./router";
import * as dayjs from "dayjs";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap";

import store from "./_store";

let app = createApp(App);

// Stripe Public Key
app.config.globalProperties.STRIPE_PK =
  "pk_live_51LOS2BLjJ1YqrBEVWTjIPwxf3gM0Qd9m3NiVMUyHPDVhHOO51ym6UMSMY4KsQxc7qso3zlGaGBQA59XmRWqiRH6400LPgpL7kX";

app.use(store).use(router).mount("#app");
